import React from "react";
import { BookOpenIcon, CameraIcon, ClipboardListIcon, FlaskConicalIcon, GiftIcon, PaletteIcon, ShieldCheckIcon, StethoscopeIcon, BoxIcon } from "lucide-react";
const map: Record<string, BoxIcon> = {
  book: BookOpenIcon,
  camera: CameraIcon,
  clipboard: ClipboardListIcon,
  flask: FlaskConicalIcon,
  gift: GiftIcon,
  palette: PaletteIcon,
  shield: ShieldCheckIcon,
  stethoscope: StethoscopeIcon
};
type Props = {
  name: string;
  className?: string;
};
export function IconByName({
  name,
  className
}: Props) {
  const Icon = map[name] ?? ClipboardListIcon;
  return <Icon className={className} aria-hidden="true" data-id="element-40" data-mp="3gg3skm43rm0n" />;
}